// extracted by mini-css-extract-plugin
export default {"inputFieldSection":"style_inputFieldSection__853FC","label":"style_label__lXjAn","input":"style_input__7+np7"};